// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__d9hgC","inner":"Footer_inner__3T7l5","nextIcon":"Footer_nextIcon__UaTu0","innerLeft":"Footer_innerLeft__26mKv"};